import { render, staticRenderFns } from "./UserAccessLogs.vue?vue&type=template&id=19575b7c&lang=pug"
import script from "./UserAccessLogs.vue?vue&type=script&lang=js"
export * from "./UserAccessLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19575b7c')) {
      api.createRecord('19575b7c', component.options)
    } else {
      api.reload('19575b7c', component.options)
    }
    module.hot.accept("./UserAccessLogs.vue?vue&type=template&id=19575b7c&lang=pug", function () {
      api.rerender('19575b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/UserAccessLogs.vue"
export default component.exports